module.exports = __webpack_public_path__ + "static/media/2 Train-Lateral_Z2.cce7810e.png";